import { useCallback } from 'react'
import { useSlate } from 'slate-react'

import { isMarkActive } from 'core-components/library/richTextEditor/helpers/slateHelper'

import { INLINE_FORMATS } from '../../../interface/custom-types'

import { BaseButton, IBaseButton } from './BaseButton'

export function MarkStyleButton(props: IBaseButton<INLINE_FORMATS>) {
  const editor = useSlate()

  const callIsActive = useCallback(() => {
    return isMarkActive(editor, props.format)
  }, [])

  return <BaseButton {...props} callIsActive={callIsActive} />
}
